import { render, staticRenderFns } from "./wishlist-row.vue?vue&type=template&id=63e7b729&scoped=true&"
import script from "./wishlist-row.vue?vue&type=script&lang=js&"
export * from "./wishlist-row.vue?vue&type=script&lang=js&"
import style0 from "./wishlist-row.vue?vue&type=style&index=0&id=63e7b729&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7b729",
  null
  
)

export default component.exports